import { useCallback, useEffect, useState } from 'react';

type UseEntityTrendsDateSelectionInput = {
  isLatestMode: boolean;
};

type UseEntityTrendsDateSelectionResult = {
  selectedStartDay: string | null;
  selectedEndDay: string | null;
  chartSelectedStartDay: string | null;
  chartSelectedEndDay: string | null;
  setSelectedStartDay: (nextDay: string | null) => void;
  setSelectedEndDay: (nextDay: string | null) => void;
  setChartSelectedStartDay: (nextDay: string | null) => void;
  setChartSelectedEndDay: (nextDay: string | null) => void;
  clearSelectedAndChartDates: () => void;
};

export const useEntityTrendsDateSelection = ({
  isLatestMode,
}: UseEntityTrendsDateSelectionInput): UseEntityTrendsDateSelectionResult => {
  const [selectedStartDay, setSelectedStartDay] = useState<string | null>(null);
  const [selectedEndDay, setSelectedEndDay] = useState<string | null>(null);
  const [chartSelectedStartDay, setChartSelectedStartDay] = useState<string | null>(null);
  const [chartSelectedEndDay, setChartSelectedEndDay] = useState<string | null>(null);

  useEffect(() => {
    if (!isLatestMode) {
      setChartSelectedStartDay(null);
      setChartSelectedEndDay(null);
    }
  }, [isLatestMode]);

  const clearSelectedAndChartDates = useCallback(() => {
    setChartSelectedStartDay(null);
    setChartSelectedEndDay(null);
    setSelectedStartDay(null);
    setSelectedEndDay(null);
  }, []);

  return {
    selectedStartDay,
    selectedEndDay,
    chartSelectedStartDay,
    chartSelectedEndDay,
    setSelectedStartDay,
    setSelectedEndDay,
    setChartSelectedStartDay,
    setChartSelectedEndDay,
    clearSelectedAndChartDates,
  };
};
